import { z } from 'zod';
import { moneySchema } from './common.schemas';

const positiveMoney = moneySchema.refine((money) => money.amountMinor > 0, { message: 'Amount must be more than zero', path: ['amountMinor'] });

/**
 * Dispatching an assigned trip (gitaumoses4/chukua#53). The crew is not in the body: dispatch commits the one the trip already holds, so a
 * stale picker answer cannot choose a different one. Every allocation is optional. `idempotencyKey` makes a repeated request (a double click, a
 * retry after a timeout) return the first result instead of dispatching twice. Fuel is whole litres; weighbridge is an expected charge, like tolls.
 */
export const dispatchTripInputSchema = z
  .object({
    idempotencyKey: z.string().min(1).max(200),
    fuelAllocationLitres: z.number().int().positive().max(100_000).optional(),
    advance: positiveMoney.optional(),
    expectedTolls: positiveMoney.optional(),
    expectedWeighbridge: positiveMoney.optional(),
  })
  .strict();
export type DispatchTripInput = z.infer<typeof dispatchTripInputSchema>;
